var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocketHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29421",
    "data-name": "Group 29421",
    transform: "translate(-87 -502.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(87 502.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29420",
    "data-name": "Group 29420",
    transform: "translate(-13.336 -0.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50800",
    "data-name": "Path 50800",
    d: "M6.7,138.956H6.658l-5.58-.348a.618.618,0,0,1-.5-.919,9.126,9.126,0,0,1,2.072-2.374,6.691,6.691,0,0,1,6.084-1.37.618.618,0,0,1,.4.873l-1.88,3.8a.619.619,0,0,1-.554.344Zm0,0",
    transform: "translate(115.838 381.614)",
    fill: "#ff5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50801",
    "data-name": "Path 50801",
    d: "M247.272,300.985a.618.618,0,0,1-.617-.58l-.348-5.58a.619.619,0,0,1,.343-.593l3.8-1.881a.618.618,0,0,1,.873.4,6.69,6.69,0,0,1-1.37,6.084,9.126,9.126,0,0,1-2.374,2.072A.618.618,0,0,1,247.272,300.985Zm0,0",
    transform: "translate(-120.239 229.313)",
    fill: "#ff193d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50802",
    "data-name": "Path 50802",
    d: "M107.3,24.663l-4-4a.618.618,0,0,0-.612-.156,15.151,15.151,0,0,0-6.53,3.69,12.555,12.555,0,0,0-.987,1.113,15.314,15.314,0,0,0-2.23,4.014,20.216,20.216,0,0,0-.9,3.087,18.9,18.9,0,0,0-.414,3.292.618.618,0,0,0,.618.626h.008a18.867,18.867,0,0,0,3.292-.413,20.2,20.2,0,0,0,3.087-.9,15.31,15.31,0,0,0,4.014-2.23,12.509,12.509,0,0,0,1.114-.987,15.148,15.148,0,0,0,3.69-6.53A.618.618,0,0,0,107.3,24.663Zm0,0",
    transform: "translate(28.31 490.359)",
    fill: "#e1f1fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50803",
    "data-name": "Path 50803",
    d: "M43.449,309.813l-3-3a.618.618,0,0,0-.819-.049,6.029,6.029,0,0,0-.541.479,8.627,8.627,0,0,0-2.15,5.45.619.619,0,0,0,.618.626h.008a8.626,8.626,0,0,0,5.45-2.15,6.022,6.022,0,0,0,.479-.541.618.618,0,0,0-.049-.819Zm0,0",
    transform: "translate(80.836 215.533)",
    fill: "#fff261"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50804",
    "data-name": "Path 50804",
    d: "M76.949,240.762,75.111,242.6a.618.618,0,0,0,0,.874l4.9,4.9a.618.618,0,0,0,.874,0l1.838-1.838Zm0,0",
    transform: "translate(44.353 278.801)",
    fill: "#1b3b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50805",
    "data-name": "Path 50805",
    d: "M282.858,140.022a1.886,1.886,0,1,1,1.334-.552,1.874,1.874,0,0,1-1.334.552Zm0,0",
    transform: "translate(-153.533 379.176)",
    fill: "#06ccab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50806",
    "data-name": "Path 50806",
    d: "M268.193,125.958a2.491,2.491,0,1,1,1.761-.73A2.474,2.474,0,0,1,268.193,125.958Zm0-3.745a1.254,1.254,0,1,0,.887.367A1.247,1.247,0,0,0,268.193,122.213Zm0,0",
    transform: "translate(-138.869 393.845)",
    fill: "#1b3b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50807",
    "data-name": "Path 50807",
    d: "M376.39.182A.615.615,0,0,0,375.945,0a20.189,20.189,0,0,0-4.976.836L375.735,5.6a20.192,20.192,0,0,0,.836-4.976.618.618,0,0,0-.181-.445Zm0,0",
    transform: "translate(-239.968 510.031)",
    fill: "#ff5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50808",
    "data-name": "Path 50808",
    d: "M111.7,77.558l-2-2L96.211,89.046a.618.618,0,0,0,.437.181h.008a18.869,18.869,0,0,0,3.292-.413,20.2,20.2,0,0,0,3.087-.9,15.308,15.308,0,0,0,4.014-2.23,12.514,12.514,0,0,0,1.114-.987,15.148,15.148,0,0,0,3.69-6.53A.618.618,0,0,0,111.7,77.558Zm0,0",
    transform: "translate(23.914 437.465)",
    fill: "#cdebfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50809",
    "data-name": "Path 50809",
    d: "M47.84,350.545l-1.5-1.5-4.827,4.827h0a.619.619,0,0,0,.437.181h.008a8.628,8.628,0,0,0,5.45-2.151,6.009,6.009,0,0,0,.479-.541.618.618,0,0,0-.049-.819Zm0,0",
    transform: "translate(76.444 174.802)",
    fill: "#fdbf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50810",
    "data-name": "Path 50810",
    d: "M143.638,313.664l-2.275,2.275,2.449,2.449a.618.618,0,0,0,.874,0l1.838-1.838Zm0,0",
    transform: "translate(-19.45 208.784)",
    fill: "#001035"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50811",
    "data-name": "Path 50811",
    d: "M297.574,150.207h0l-2.667,2.667h0a1.886,1.886,0,1,0,2.667-2.667Zm0,0",
    transform: "translate(-166.916 365.771)",
    fill: "#1cadb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50812",
    "data-name": "Path 50812",
    d: "M287.624,139.406l-.874.874a1.254,1.254,0,0,1-1.774,1.774h0l-.874.874h0a2.491,2.491,0,0,0,3.523-3.523Zm0,0",
    transform: "translate(-156.539 376.145)",
    fill: "#001035"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50813",
    "data-name": "Path 50813",
    d: "M434.21,4.574l-3.038,3.038L433.555,10a20.191,20.191,0,0,0,.836-4.976.618.618,0,0,0-.181-.445Zm0,0",
    transform: "translate(-297.788 505.64)",
    fill: "#ff193d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketHighlighted);
export default __webpack_public_path__ + "static/media/rocketHighlighted.15a950b699cdf69a094f92f989ddb94c.svg";
export { ForwardRef as ReactComponent };